import { createSlice } from '@reduxjs/toolkit'
import { initialState } from './type'
import { getCompletedSessions, getSessions } from './api'

export const liveSlice = createSlice({
  name: 'sessions',
  initialState,
  reducers: {},
  extraReducers: {
    [getCompletedSessions.pending.toString()]: (state) => {
      state.isLoading = true
    },
    [getCompletedSessions.fulfilled.toString()]: (state, action) => {
      state.isLoading = false
      state.completedSessions = action?.payload
    },
    [getCompletedSessions.rejected.toString()]: (state) => {
      state.isLoading = false
      state.completedSessions = []
    },
    [getSessions.pending.toString()]: (state) => {
      state.isLoading = true
    },
    [getSessions.fulfilled.toString()]: (state, action) => {
      state.isLoading = false
      const { sessionTense, sessions } = action?.payload
      switch (sessionTense) {
        case 'UPCOMING':
          state.upComingSessions = sessions
          break
        case 'LIVE':
          state.liveSessions = sessions
          break
        default:
          state.sessionDetails = sessions
      }
    },
    [getSessions.rejected.toString()]: (state) => {
      state.isLoading = false
      state.upComingSessions = []
      state.liveSessions = []
      state.sessionDetails = []
    }
  }
})

export default liveSlice.reducer
